import HotelOutlinedIcon from '@mui/icons-material/HotelOutlined';
import LinkOutlinedIcon from '@mui/icons-material/LinkOutlined';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';

import type { RatesAndInventoryTab } from './types';

export const RATES_AND_INVENTORY_TABS: Array<{
  icon: typeof LocalOfferOutlinedIcon;
  label: string;
  value: RatesAndInventoryTab;
}> = [
  { icon: LocalOfferOutlinedIcon, label: 'Rate Plans', value: 'rate-plans' },
  { icon: HotelOutlinedIcon, label: 'Room types', value: 'room-types' },
  { icon: LinkOutlinedIcon, label: 'Link deal options', value: 'link-deal-options' },
];

export function getRatesAndInventoryTab(tab: string | null | undefined): RatesAndInventoryTab {
  return RATES_AND_INVENTORY_TABS.some((ratesAndInventoryTab) => ratesAndInventoryTab.value === tab)
    ? (tab as RatesAndInventoryTab)
    : 'rate-plans';
}
